<template>
  <div id="login">
    <!-- TITLE//S-->
    <div class="page-header">
      <h3>{{ $t("login.login") }}</h3>
    </div>
    <!-- TITLE//E-->
    <div class="login-info-text">
      <p class="help-block" v-html="$t('sms.description')"></p>
    </div>

    <!-- LOGIN FORM//S -->
    <div class="well login-wrap">
      <!-- <span class="timer">{{remain}}</span> -->
      <div class="input-group">
        <div class="input-master input-custom vs-con-input-label">
          <label for class="vs-input-label">{{
            $t("sms.SMSVerification")
          }}</label>
          <input
            type="text"
            maxlength="6"
            pattern="[0-9]*"
            inputmode="decimal"
            :placeholder="$t('sms.verificationcode')"
            class="form-control"
            v-model="authNumber"
          />
        </div>
        <span class="input-group-btn">
          <vs-button
            color="dark"
            vs-size="small"
            class="btn-wide"
            type="filled"
            @click.prevent="sendSms"
            v-if="!send"
            >{{ $t("sms.sendVerification") }}</vs-button
          >
          <vs-button
            color="dark"
            vs-size="small"
            class="btn-wide"
            type="filled"
            v-else-if="remain"
            >{{ remain }}</vs-button
          >
          <vs-button
            color="dark"
            vs-size="small"
            class="btn-wide"
            type="filled"
            v-else
            @click.prevent="sendSms"
            >재전송</vs-button
          >
        </span>
      </div>
      <p class="help-block text-center">{{ $t("sms.info[1]") }}</p>
      <vs-button
        color="danger"
        class="btn-block custom"
        type="filled"
        @click="btnLoginHandler"
        >{{ $t("login.login") }}</vs-button
      >
    </div>
    <!-- <div class="login-bottom">
      <a @click="phoneResetPopup = true">{{ $t('verificationReset.title') }}</a>
    </div>
    <div class="notice-small">
      ※ Flybit 회원가입 시 등록된 휴대폰 번호로 인증 메시지가 발송됩니다.<br />
      ※ 입력시간 초과 시 ‘인증번호 발송’ 버튼을 다시 눌러주세요.<br />
      ※ 휴대폰 분실 등의 이유로 인증을 완료할 수 없으세요?
    </div>-->
    <PhoneReset
      :phone-reset-step-popup="phoneResetPopup"
      @phone-reset-popup-cancel="phoneResetPopup = false"
    />
    <!-- LOGIN FORM//E -->
    <vs-popup
      :title="$t('login.popup.loginAccess.title')"
      :active.sync="loginBlockModal"
    >
      <p class="text-center">
        <span class="icon err"></span>
        <br />
        {{ $t("login.popup.loginAccess.content.SMS/OTPVerification") }}
      </p>
      <p class="text-center">
        {{
          $t(
            "login.popup.loginAccess.content.emailVerificationAndPasswordReset"
          )
        }}
      </p>
      <p class="text-center">
        {{ $t("login.popup.loginAccess.content.SMS/OTPAuthenticationFailure") }}
      </p>
      <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-button
            color="#717171"
            @click.prevent="loginBlockModal = false"
            class="btn-gray btn-block"
            >{{ this.$t("confirm.cancel") }}</vs-button
          >
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-button
            color="primary"
            @click.prevent="closeNGo('loginBlockModal', 'PwReset')"
            class="btn-block custom"
            type="filled"
            >{{ $t("resetPassword.title") }}</vs-button
          >
        </vs-col>
      </vs-row>
    </vs-popup>
    <!-- POPUP 로그인 제한 안내//E -->
  </div>
</template>
<script>
import Moment from "moment";
import Api from "@/common/Api";
import PhoneReset from "./phoneReset";
export default {
  components: {
    PhoneReset,
  },
  created() {
    if (!_.has(this.$route.params, "token")) {
      this.$router.back();
    }
    setInterval(this.remainTime, 1000);

    //이미 로그인 페이지 인경우 메인 페이지로 이동합니다.
    if (this.$store.getters.isLogin) {
      this.$router.push("/");
    }
  },
  data() {
    return {
      actives: 1,
      remain: "00:00",
      expire: +Moment().add(3, "minutes"),
      requestCode: "",
      send: false,
      registPhoneModal: false,
      authNumber: "",
      phoneResetPopup: false,
      loginBlockModal: false,
    };
  },
  methods: {
    sendSms() {
      Api.User.requestAuth({
        token: this.$route.params.token,
      })
        .then((response) => {
          this.expire = +Moment().add(3, "minutes");
          this.remainTime();
          this.send = true;
        })
        .catch((err) => {
          const { code, message } = _.get(err, ["response", "data", "header"], {
            code: "9999",
            message: "로그인에 실패했습니다. 인증번호를 확인해주세요.",
          });
          // this.$message(message);
          this.$vs.notify({
            title: "안내",
            text: message,
            position: "top-left",
          });
          // this.$router.back();
        });
    },
    remainTime() {
      const remain = Moment(+this.expire - +Moment());
      if (+remain > 0) {
        this.remain = remain.format("mm:ss");
      } else {
        this.remain = false;
      }
    },
    async btnLoginHandler() {
      if (!this.authNumber) {
        this.$vs.notify({
          title: this.$t("notice.title.error"),
          text: this.$t("notice.content.enterVerificaiton"),
          position: "top-right",
          color: "danger",
        });
        return false;
      }
      try {
        const { data } = await Api.User.loginAuth({
          authvalue: this.authNumber,
          means: "SMS",
          token: this.$route.params.token,
        });

        if (data.result) {
          this.$store.dispatch("getPersonalInfo");
          this.$store.commit("LOGIN", data.result);

          this.$vs.notify({
            title: this.$t("notice.title.attention"),
            text: this.$t("notice.content.loginSuccessful"),
            position: "top-left",
          });
          let referrer = _.get(this, ["$route", "params", "refName"], "Main");
          const fullPath = _.get(this, ["$route", "params", "fullPath"], null);

          if (fullPath) {
            // console.log("fullPath");
            if (data.result.dueDiligenceInfo) {
              // console.log("인증함");

              // 재이행주기 도래 30일 전 ~ d-day
              const reauthDate = data.result.dueDiligenceInfo.reAuthDate; // 재이행주기 도래일
              if (reauthDate) {
                // console.log("재이행주기");

                //재이행주기 도래 15일 전
                const format = Moment(reauthDate).format("YYYY-MM-DD"); // 시간 제외
                const result = Moment(format)
                  .subtract(30, "d")
                  .diff(Moment(), "days"); // 31일 전 계산(00시 기준으로 계산하기 때문에 30일로 입력)
                if (result >= -30 && result <= 0) {
                  // console.log("재이행주기 도래 15일 내");
                  // 재이행주기 도래 15일 내
                  this.$router.replace({
                    name: referrer,
                    query: { reAuth: "Y" },
                  });
                  return;
                }
              }
            }
            this.$router.replace(fullPath);
          } else {
            // console.log("fullPath 없음");
            // 재이행주기 도래 30일 전 ~ d-day
            const reauthDate = data.result.dueDiligenceInfo.reAuthDate; // 재이행주기 도래일
            if (reauthDate) {
              // console.log("fullPath 없음");
              //재이행주기 도래 15일 전
              const format = Moment(reauthDate).format("YYYY-MM-DD"); // 시간 제외
              const result = Moment(format)
                .subtract(30, "d")
                .diff(Moment(), "days"); // 31일 전 계산(00시 기준으로 계산하기 때문에 30일로 입력)
              if (result >= -30 && result <= 0) {
                // console.log("재이행주기 도래 15일 이내");
                //재이행주기 도래 15일 내
                this.$router.replace({
                  name: referrer,
                  query: { reAuth: "Y" },
                });
                return;
              }
            }

            this.$router.replace({ name: referrer });
          }
        }
      } catch (error) {
        console.log("error", error);
        const { code, message } = _.get(error, ["response", "data", "header"], {
          code: "9999",
          message: "로그인에 실패했습니다. 인증번호를 확인해주세요.",
        });
        this.$vs.notify({
          title: this.$t("notice.title.error"),
          text: this.$t("notice.content.checkVerification"),
          position: "top-right",
          color: "danger",
        });
      }
    },
    closeNGo(modalName, routeName) {
      this[modalName] = false;
      this.$nextTick(() => {
        this.$router.push({ name: routeName });
      });
    },
  },
};
</script>
<style scoped>
.vs-button-dark.vs-button-filled {
  height: 30px;
}
.login-bottom > a {
  cursor: pointer;
}
.vs-con-input-label {
  width: 100% !important;
}
</style>
